// BasicosTabXL - Sprint 44 Fase 3 Vista 10.
import XLInput from '../../../components/xl/XLInput';
import XLSelect from '../../../components/xl/XLSelect';
import { MONEDA_OPTIONS, ESTADOS, showGuia, showConsol } from '../utils';

export default function BasicosTabXL({ form, set }) {
  const t = form.tipo_importacion;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
      <XLInput label="Referencia *" value={form.referencia}
        onChange={(e) => set('referencia', e.target.value)} placeholder="IMP-0001" />
      <XLInput label="Fecha" type="date" value={form.fecha || ''}
        onChange={(e) => set('fecha', e.target.value)} />
      <div style={{ gridColumn: '1 / -1' }}>
        <XLInput label="Proveedor" value={form.proveedor || ''}
          onChange={(e) => set('proveedor', e.target.value)}
          placeholder="Nombre del proveedor" />
      </div>
      <XLSelect label="Moneda base" value={form.moneda_base}
        onChange={(e) => set('moneda_base', e.target.value)}
        options={MONEDA_OPTIONS} />
      <XLSelect label="Estado" value={form.estado}
        onChange={(e) => set('estado', e.target.value)} options={ESTADOS} />
      <XLInput label="Pais origen" value={form.pais_origen || ''}
        onChange={(e) => set('pais_origen', e.target.value)} placeholder="USA" />
      <XLInput label="Pais destino" value={form.pais_destino || ''}
        onChange={(e) => set('pais_destino', e.target.value)} placeholder="Colombia" />
      <div style={{ gridColumn: '1 / -1' }}>
        <XLInput label="Descripcion" value={form.descripcion || ''}
          onChange={(e) => set('descripcion', e.target.value)}
          placeholder="Lote trimestre..." />
      </div>
      {showGuia(t) && (
        <div style={{ gridColumn: '1 / -1' }}>
          <XLInput label="Guia aerea (AWB)" value={form.guia_aerea || ''}
            onChange={(e) => set('guia_aerea', e.target.value)}
            placeholder="Ej: 123-12345678" />
        </div>
      )}
      {showConsol(t) && (
        <>
          <XLInput label="Peso (kg)" type="number" min="0" step="0.001"
            value={form.peso_kg == null ? '' : form.peso_kg}
            onChange={(e) => set('peso_kg', e.target.value)} />
          <XLInput label="Volumen (m3)" type="number" min="0" step="0.0001"
            value={form.volumen_m3 == null ? '' : form.volumen_m3}
            onChange={(e) => set('volumen_m3', e.target.value)} />
        </>
      )}
    </div>
  );
}
